import React from "react";
import { Carousel } from "react-bootstrap";
import "./ContactPage.css";

const ContactPage = () => {
  return (
    <div className="contact-page">
      {/* ========== SLIDES ========== */}
      <div>
        <Carousel fade indicators={true} interval={5000} controls={false}>
          {[
            {
              title: "Let’s Connect",
              sub: "Reach out for inquiries, investments, or collaboration.",
              img: "https://images.unsplash.com/photo-1556761175-4b46a572b786?auto=format&fit=crop&w=1500&q=80",
              btn: "Send Us a Message",
              href: "#contact-form",
            },
            {
              title: "Visit Our Office",
              sub: "Located just 5 minutes from Gachibowli Circle",
              img: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1500&q=80",
              btn: "Get Directions",
              href: "https://maps.google.com",
            },
            {
              title: "Speak with Our Experts",
              sub: "Call us or connect instantly via WhatsApp.",
              img: "https://images.unsplash.com/photo-1588702547923-7093a6c3ba33?auto=format&fit=crop&w=1500&q=80",
              btn: "Start WhatsApp Chat",
              href: "https://wa.me/919999999999?text=Hello",
            },
            {
              title: "We’re Here for You",
              sub: "Mon–Sat | 9:00 AM – 6:00 PM",
              img: "https://images.unsplash.com/photo-1517701604592-004e3f2016f5?auto=format&fit=crop&w=1500&q=80",
              btn: "Book a Visit",
              href: "#callback",
            },
            {
              title: "What Our Clients Say",
              sub: "“The team was extremely responsive and guided us clearly.” — Satisfied Client",
              img: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?auto=format&fit=crop&w=1500&q=80",
              btn: "View More Testimonials",
              href: "#testimonials",
            },
          ].map((slide, i) => (
            <Carousel.Item key={i}>
              <div
                className="carousel-slide"
                style={{ backgroundImage: `url(${slide.img})` }}
              >
                <div className="carousel-caption text-white">
                  <h1 className="fw-bold">{slide.title}</h1>
                  <p className="lead">{slide.sub}</p>
                  <a
                    href={slide.href}
                    className="btn btn-outline-light mt-3"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {slide.btn}
                  </a>
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

      {/* ========== CONTACT FORM ========== */}
      <div id="contact-form" className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-4">Get In Touch With Us</h2>
          <p className="text-center mb-5">
            We’re here to help. Reach out for inquiries, investments, or partnership opportunities.
          </p>
          <form className="row g-4 mx-auto" style={{ maxWidth: "800px" }}>
            <div className="col-md-6">
              <input type="text" className="form-control" placeholder="Full Name *" required />
            </div>
            <div className="col-md-6">
              <input type="email" className="form-control" placeholder="Email Address *" required />
            </div>
            <div className="col-md-12">
              <input type="tel" className="form-control" placeholder="Mobile Number (optional)" />
            </div>
            <div className="col-md-12">
              <textarea className="form-control" rows="5" placeholder="Your Message *" required />
            </div>
            <div className="col-12 text-center">
              <button type="submit" className="btn btn-primary px-4">
                Send Message
              </button>
              <p className="mt-3 text-success">
                Thank you for contacting us! We’ll get back to you shortly.
              </p>
            </div>
          </form>
        </div>
      </div>

      {/* ========== MAP & DETAILS ========== */}
      <div className="bg-white py-5" id="map">
        <div className="container-fluid">
          <h2 className="text-center mb-4">Our Office Location</h2>
          <div className="row g-4">
            <div className="col-md-8 px-5">
              <iframe
                src="https://maps.google.com/maps?q=Gachibowli,%20Hyderabad&t=&z=13&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
            <div className="col-md-4">
              <div className="info-box mb-3">
                <h5>📍 Address</h5>
                <p>Plot 123, Gachibowli, Hyderabad, Telangana</p>
              </div>
              <div className="info-box mb-3">
                <h5>📞 Phone Support</h5>
                <p>+91 99999 99999</p>
              </div>
              <div className="info-box mb-3">
                <h5>📧 Email Support</h5>
                <p>support@example.com</p>
              </div>
              <div className="info-box mb-3">
                <h5>🕒 Office Timings</h5>
                <p>Mon–Sat | 9:00 AM – 6:00 PM</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ========== REQUEST CALLBACK ========== */}
      <div id="callback" className="bg-light py-5">
        <div className="container">
          <h2 className="text-center mb-4">Request a Callback / Book a Visit</h2>
          <form className="row g-4 mx-auto" style={{ maxWidth: "700px" }}>
            <div className="col-md-6">
              <input type="text" className="form-control" placeholder="Your Name" required />
            </div>
            <div className="col-md-6">
              <input type="tel" className="form-control" placeholder="Phone Number" required />
            </div>
            <div className="col-md-6">
              <input type="datetime-local" className="form-control" required />
            </div>
            <div className="col-md-6">
              <select className="form-select" required>
                <option value="">Select Visit Type</option>
                <option>Site Visit</option>
                <option>Consultation</option>
                <option>Project Info</option>
              </select>
            </div>
            <div className="col-12 text-center">
              <button className="btn btn-success px-4" type="submit">
                Book Now
              </button>
              <p className="mt-3 text-success">We’ve scheduled your request. Our team will reach out soon.</p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
